import { Sparkles } from "lucide-react";
import styles from "./ImproveAIButton.module.css";

const cx = (...classNames) => classNames.filter(Boolean).join(" ");

// The shared "Improve" trigger — animated gradient-ring border (matching the
// SOLA Icon "Bordered Circle" treatment), purple text, solid purple fill on
// hover/active. Used by RichAIField's toolbar and AITextField's compact mode.
export default function ImproveAIButton({ onClick, active, className, label = "Improve" }) {
  return (
    <button
      type="button"
      className={cx(styles.button, active && styles.active, className)}
      onMouseDown={(event) => event.preventDefault()}
      onClick={onClick}
    >
      <Sparkles size={14} />
      {label}
    </button>
  );
}
